/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { FragmentComponentOptions_callback, getAddonPath } from 'webcommon/lazy-load-commonjs/foxit';
import { FoxitPdfRendererBase } from './FoxitPdfRendererBase';

@Injectable()
export class FoxitViewRenderer extends FoxitPdfRendererBase {
  readonly template = `
    <webpdf>
      <toolbar name="toolbar" class="fv__ui-toolbar-scrollable">
        <tabs name="toolbar-tabs">
          <tab title="toolbar.tabs.home.title" name="home-tab">
            <group-list name="home-toolbar-group-list">
              <group name="home-tab-group-hand" retain-count="4">
                <hand-button></hand-button>
                <selection-button></selection-button>
                <download-file-button></download-file-button>
                <print:print-button></print:print-button>
              </group>
              <group name="comment-tab-group-stamp" retain-count="2">
                <single-page-button></single-page-button>
                <continuous-page-button></continuous-page-button>
              </group>
              <group name="home-tab-group-nav" retain-count="2">
                <goto-page-input></goto-page-input>
              </group>
              <group name="home-tab-group-zoom">
                <zoom-out-button></zoom-out-button>
                <editable-zoom-dropdown></editable-zoom-dropdown>
                <zoom-in-button></zoom-in-button>
              </group>
            </group-list>
          </tab>
        </tabs>
      </toolbar>
      <viewer></viewer>
      <template name="template-container">
      </template>
    </webpdf>
  `;

  onClickDownloadFile: FragmentComponentOptions_callback = () => {
    // noop by default;
    // we could also make this default to the actual foxit default behavior if we want to
  };

  onClickPrintFile: FragmentComponentOptions_callback = () => {
    // noop by default;
    // if you want the default behavior,
    // you need <print:print-dialog></print:print-dialog> in the <template> tag
  };

  // eslint-disable-next-line @typescript-eslint/member-ordering
  override readonly pdfUI = this.createPDFUI({
    fragments: [
      {
        config: {
          callback: () => this.onClickDownloadFile(),
        },
        target: 'download-file-button',
      },
      {
        config: {
          callback: () => this.onClickPrintFile(),
        },
        target: 'print-button',
      },
    ],
    template: this.template,
    addons: [
      getAddonPath('print'),
    ],
  });
}


// this is from FoxitPDFSDKforWeb_DeveloperGuide.pdf:
//
// const exampleTemplate = `
//   <!-- Layout template must take <webpdf> as the root component. -->
//   <webpdf>
//     <!-- Layout templates support all html tags and properties. -->
//     <div class="toolbar" style="display:flex;flex-direction:row;padding:6px">
//       <!-- The colon prefix is the name of the component module, and the component name and module name
//       must be in lowercase. -->
//       <print:print-button></print:print-button>
//       <!-- The parameters that begin with @ are used to mark directives, the content that follow with @ is the
//       name of directives. If the directive is registered in a non-root module, then the directive name should be written
//       in the @module-name:directive-name format. -->
//
//       <xbutton name="create-typewriter-button" @controller="states:CreateTypewriterController" iconclass="fv__icon-toolbar-typewriter">toolbar.create.typewriter</xbutton>
//     </div>
//     <div class="fv__ui-body">
//       <!-- Viewer is used to display the area of PDF, so there must be a viewer component in the layout template -->
//       <viewer @touch-to-scroll></viewer>
//     </div>
//     <!-- Template is a re-written html template tag. It is typically used to hold the components that do not need to
//     be displayed immediately, such as dialog boxes, right-click menus, floating boxes, and etc.. -->
//     <template name="template-container">
//       <print:print-dialog></print:print-dialog>
//     </template>
//   </webpdf>
// `;
